import { render } from "./AssetsForm.vue?vue&type=template&id=91adb320&scoped=true"
import script from "./AssetsForm.vue?vue&type=script&lang=js"
export * from "./AssetsForm.vue?vue&type=script&lang=js"

import "./AssetsForm.vue?vue&type=style&index=0&id=91adb320&scoped=true&lang=css"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91adb320"]])

export default __exports__